import { onlineManager } from '@tanstack/react-query';

import { ConnectivityServiceType } from './connectivity-service';
import { OnlineConnectionService } from './online-connection-service';

export const bindTanstackQueryOnline = (connectivityService: ConnectivityServiceType) => {
  onlineManager.setEventListener((setOnline) => {
    const subscription = connectivityService.asObservable.subscribe(() => {
      setOnline(!connectivityService.isLocked);
    });

    return () => subscription.unsubscribe();
  });
};

export const bindVisibilityChange = (onlineConnectionService: OnlineConnectionService) => {
  const handler = () => {
    if (document.visibilityState === 'visible') {
      onlineConnectionService.goOnline();
    }
  };

  document.addEventListener('visibilitychange', handler);

  return () => {
    document.removeEventListener('visibilitychange', handler);
  };
};
